// extracted by mini-css-extract-plugin
export default {"basicHeader":"basicHeader___11idH","label":"label___9J4BU","text":"text___Xtu9p","wrapper":"wrapper___1-Zs1","bullSeparator":"bullSeparator___P07xc"};